export const DEFAULT_LICENSE_DAYS = 15

function resolveLicenseDays(value: unknown) {
  const days = Number(value)
  return Number.isInteger(days) && days >= 1 && days <= 365 ? days : DEFAULT_LICENSE_DAYS
}

export const licenseDays = resolveLicenseDays(import.meta.env.VITE_LICENSE_DAYS)
export const licenseDurationLabel = `${licenseDays} ${licenseDays === 1 ? 'día' : 'días'}`
